import axios from "@/utils/request.js";
import qs from "qs"
// 禁言新增
const forbiddenuserAdd = (params) => axios({
  url: '/api/web-manager/live/forbiddenuser/add',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 禁言删除
const Deleteforbiddenuser = (params) => axios({
  url: '/api/web-manager/live/forbiddenuser/unforbid',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 禁言 编辑 保存
const forbiddenuserEdit = (params) => axios({
  url: '/api/web-manager/live/forbiddenuser/edit',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 自增同问 禁言
const forbiddenuserAddcount = (params) => axios.get('/api/web-manager/live/forbiddenuser/addcount', {
  params
})
// 自增同问 禁言
const forbiddenuserMinuscount = (params) => axios.get('/api/web-manager/live/forbiddenuser/minuscount', {
  params
})

// 查找全部用户 禁言
const forbiddenuserPage = (params) => axios.get('/api/web-manager/live/forbiddenuser/page', {
  params
})
// 根据用户id查询用户信息 禁言
const forbiddenuserPreview = (params) => axios.get('/api/web-manager/live/forbiddenuser/preview', {
  params
})
// 新增 直播 保存
const tvAdd = (params) => axios({
  url: '/api/web-manager/live/tv/add',
  method: 'post',
  data: params
})

// 编辑 直播 保存
const tvEdit = (params) => axios({
  url: '/api/web-manager/live/tv/edit',
  method: 'post',
  
  data:params
})

// 删除直播 支持批量
const tvDelete = (params) => axios({
  url: '/api/web-manager/live/tv/delete',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})

// 删除用户
const forbiddenuserDelete = (params) => axios({
  url: '/api/web-manager/live/forbiddenuser/delete',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 修改电视直播状态
const tvmMdifyState = (params) => axios({
  url: '/api/web-manager/live/tv/modifyState',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})

// 节目直播
const tvPage = (params) => axios.get('/api/web-manager/live/tv/page', {
  params
})
// 直播列表无验证
const tvPageNotoken = (params) => axios.get('/api/web-manager/live/tv/page/notoken', {
  params
})
// 根据ID查询单个电视频道  （电视详情）
const tvPrview = (params) => axios({
  url: '/api/web-manager/live/tv/preview',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 根据ID查询单个电视频道  （电视详情）notoken
const tvPrviewNotoken = (params) => axios({
  url: '/api/web-manager/live/tv/previewnotoken',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
const timeshift = (params) => axios.get('/shift', {
  params
})


// 根据ID查询单个电视频道echarts 统计数据
const tvCount = (params) => axios.get('/api/web-manager/live/tv/count/notoken', {
  params
})

// 获取直播统计时长
const getCount = (params) => axios({
  url: '/api/web-manager/live/tv/getCount',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 获取活动直播统计时长
const activityGetCount = (params) => axios({
  url: '/api/web-manager/live/activity/getCount',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})


const tvPv = (params) => axios({
  url: '/api/web-manager/live/tv/pv',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
export {
  forbiddenuserAdd,
  forbiddenuserEdit,
  forbiddenuserAddcount,
  forbiddenuserMinuscount,
  forbiddenuserPage,
  forbiddenuserPreview,
  tvAdd,
  tvEdit,
  tvDelete,
  forbiddenuserDelete,
  Deleteforbiddenuser,
  tvmMdifyState,
  tvPage,
  tvPageNotoken,
  tvPrview,
  tvPrviewNotoken,
  timeshift,
  tvCount,
  getCount,
  tvPv,
  activityGetCount,
}